if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initSwiper();
        this.showActiveMedia();
      }

      initSwiper() {
        const swiperEl = this.querySelector('[data-product-media-modal-swiper]');
        if (!swiperEl || typeof Swiper === 'undefined') return;

        // If the modal is opened while hidden, Swiper needs init/update after open.
        if (swiperEl.swiper) {
          swiperEl.swiper.update();
          return;
        }

        swiperEl.swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 16,
          centeredSlides: true,
          watchOverflow: true,
          keyboard: { enabled: true },
          pagination: {
            el: swiperEl.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
          },
          observer: true,
          observeParents: true,
        });
      }

      showActiveMedia() {
        const targetMediaId = this.openedBy?.getAttribute('data-media-id');
        if (!targetMediaId) return;

        const swiperEl = this.querySelector('[data-product-media-modal-swiper]');
        const swiper = swiperEl?.swiper;

        // Preferred: Swiper-based modal (swiper-slide wrappers own the data-media-id)
        if (swiperEl && swiper) {
          const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
          const activeIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(targetMediaId));

          slides.forEach((slide) => slide.classList.remove('active'));

          if (activeIndex >= 0) {
            const activeSlide = slides[activeIndex];
            activeSlide.classList.add('active');
            swiper.slideTo(activeIndex, 0);

            // If the active slide contains deferred media, load it when needed.
            const deferred = activeSlide.querySelector('deferred-media, product-model');
            const tpl = deferred?.querySelector('template');
            const content = tpl ? tpl.content : null;
            if (deferred && typeof deferred.loadContent === 'function' && content?.querySelector('.js-youtube')) {
              deferred.loadContent();
            }
          }

          return;
        }

        // Fallback: original Dawn behavior (no Swiper)
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${targetMediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${targetMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }
  );
}
